import injector from 'vue-inject'

injector.constant('api', {
    auth: {
        location: {
            banned: 'auth/location/banned'
        },
        login: 'auth/login',
        logout: 'auth/logout',
        registration: 'auth/registration',
        user: 'user'
    },
    bonus: {
        bonus (params) {
            let url = 'bonus' + '?page=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate
            }
            if (params.sort && params.sort.length > 0) {
                for (let field in params.sort){
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url
        },
        history (params) {
            let url = 'bonus/history' + '?page=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate;
            }
            if (params.user) {
                url += '&user=' + params.user;
            }
            if (params.sort && params.sort.length > 0) {
                for (let field in params.sort){
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            if (params.filter && params.filter.length > 0) {
                for (let field in params.filter){
                    url += '&types[' + field + ']=' + params.filter[field];
                }
            }
            return url
        },
        summary (params) {
            let url = 'bonus/summary' + '?page=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate;
            }
            if (params.sort && params.sort.length > 0) {
                for (let field in params.sort){
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url;
        },
        totalIncomes: 'bonus/total-incomes'
    },
    careerLevel: {
        next: 'career-level/next-level'
    },
    codes: {
        list(params) {
            let url = 'code/user/list';

            if (params && params.currentPage) {
                url += '?currentPage=' + params.currentPage;
            }
            if (params && params.maxPerPage) {
                url += '&maxPerPage=' + params.maxPerPage;
            }

            return url;
        },
        confirm: 'code/confirm-user',
        cancel: 'code/cancel-user',
        create: 'code/create'
    },
    commissions: {
        list: 'commissions/list',
        download (period) {
            return 'commissions/monthly/' + period;
        }
    },
    countries: {
        list: 'dictionaries/country'
    },
    currency (sourceCryptoCurrency, destinationCurrency) {
        return 'currencies/rate/' + sourceCryptoCurrency + '/' + destinationCurrency;
    },
    futurepay: {
        buyWithCode: 'package/buy/code',
        buy: 'futurepay/buy-package',
        callback: 'futurepay/buy-package/callback'
    },
    history: 'users/login/history',
    invoice: {
        list: 'invoice/list',
        generate (packageId) {
            return 'invoice/create/' + packageId;
        },
        download (invoiceId) {
            return 'invoice/pdf/' + invoiceId;
        },
    },
    marketing: {
        plans: 'marketing/plans'
    },
    microWallet: {
        buyPackage : 'micro-wallet/buy-package'
    },
    mining: {
        history (params) {
            let url = 'mining/history' + '?currentPage=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate;
            }
            if (params.sort && params.sort.length > 0) {
                for (let field in params.sort){
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url;
        },
        ftoPerPowerPoint () {
            return 'mining/fto-per-power-point';
        }
    },
    notifications: {
        get (currentPage, maxPerPage) {
            return 'notifications?currentPage=' + currentPage + '&maxPerPage=' + maxPerPage;
        },
        archive: 'notifications/archive',
        read: 'notifications/read'
    },
    package: {
        bought: 'package/bought-packages',
        boughtList (params) {
            let url = 'package/bought-packages-list';

            if (params) {
                if (params.currentPage) {
                    url += '?currentPage=' + params.currentPage;
                }
                if (params.maxPerPage) {
                    url += '&maxPerPage=' + params.maxPerPage;
                }
                if (params.fromDate) {
                    url += '&fromDate=' + params.fromDate;
                }
                if (params.toDate) {
                    url += '&toDate=' + params.toDate;
                }
                if (params.sort && params.sort.length > 0) {
                    for (let field in params.sort){
                        url += '&sort[' + field + '][field]=' + params.sort[field].field;
                        url += '&sort[' + field + '][order]=' + params.sort[field].order;
                    }
                }
            } else {
                url += '?sort[0][field]=date&sort[0][order]=asc';
            }

            return url;
        },
        buy: 'package/buy'
    },
    payout: {
        list (params) {
            let url = 'payout/list';
            if (params.currentPage) {
                url += '?currentPage=' + params.currentPage;
            }
            if (params.maxPerPage) {
                url += '&maxPerPage=' + params.maxPerPage;
            }
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&fromDate=' + params.toDate;
            }
            if (params.sort && params.sort.length > 0) {
                for (let field in params.sort){
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url;
        },
        cancel: 'payout/cancel-by-user',
        confirmByUser: 'payout/confirm-by-user',
        email: 'payout/send-confirm-email',
        request: 'payout/request',
        verify (id) {
            return 'payout/verifiy/' + id;
        }
    },
    ranking: {
        list (params) {
            let url = 'user/top-qualified/list';

            if (params.currentPage) {
                url += '?currentPage=' + params.currentPage;
            }
            if (params.maxPerPage) {
                url += '&maxPerPage=' + params.maxPerPage;
            }
            if (params.careerLevel) {
                url += '&careerLevel=' + params.careerLevel;
            }

            return url;
        }
    },
    report: {
        income (fromDate, toDate, type) {
            return 'report/income/' + fromDate + '/' + toDate + '/' + type;
        },
        turnover (fromDate, toDate, type) {
            return 'report/turnover/' + fromDate + '/' + toDate + '/' + type;
        }
    },
    reports: {
        statistics: 'report/statistics'
    },
    terms: {
        fetchData: 'terms-of-use/list-regulations',
        accepted: 'terms-of-use/list-acceptances',
        sign: 'terms-of-use/sign'
    },
    token: {
        confirm: 'credentials/confirm',
        generate (userSettingName) {
            return 'credentials/generate/token/' + userSettingName;
        }
    },
    transfer: {
        miningTransfer: 'transfer/transfer-fto-mining',
        royalTransfer: 'transfer/transfer-fto-royal',
        history (params) {
            let url = 'transfer/history' + '?page=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
            if (params.fromDate) {
                url += '&fromDate=' + params.fromDate;
            }
            if (params.toDate) {
                url += '&toDate=' + params.toDate;
            }
            if (params.type) {
                url += '&type=' + params.type;
            }
            if (params.sort && params.sort.length > 0) {
                for (let field in params.sort){
                    url += '&sort[' + field + '][field]=' + params.sort[field].field;
                    url += '&sort[' + field + '][order]=' + params.sort[field].order;
                }
            }
            return url;
        },
    },
    transferToFN: {
        history (params) {
            return 'transfer-to-futurenet/history' + '?currentPage=' + params.currentPage + '&maxPerPage=' + params.maxPerPage;
        },
    },
    translation (languageCode, domain) {
        return 'translation/' + languageCode + '/' + domain;
    },
    user: {
        verification: {
            get: 'user/verification',
            request: 'user/verification/request',
        },
        changePassword: 'user/change-password',
        deactivate (emailOrLogin) {
            return 'user/' + emailOrLogin + '/deactivate';
        },
        ftoAccounts: 'user/fto-accounts',
        password: {
            change: 'user/change-password',
            remind: 'user/remind-password',
            new: 'user/new-password'

        },
        royalBonuses: 'bonus/royal-bonuses',
        settings: {
            change: 'user/change-settings',
            get: 'user/settings',
            google: 'user/google/authenticator/settings'
        },
        tree: {
            frontliners (emailOrLogin) {
                return 'user/tree/' + emailOrLogin + '/frontliners';
            },
            pathFor (emailOrLogin) {
                return 'user/tree/' + emailOrLogin + '/path';
            },
            search (query) {
                return 'user/tree/search/' + query;
            }
        },
        update: 'user/update-profile-data',
        withdraw: 'user/withdraw-royal-schedule',
    },
    withdraw: {
        send: 'withdraw',
        getLast: 'withdraw/active',
        getAll: 'withdraw'
    }
});



// WEBPACK FOOTER //
// ./src/services/api.js